module.exports = __webpack_public_path__ + "img/ignitionOff.2b408bbd.svg";